import { TagColor as Color } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type EnpsForm from 'modules/enps/store/models/Form'
import type Survey from 'modules/surveys/store/models/v2/Survey'

export const getTagColor = (survey: EnpsForm | Survey | undefined) => {
  if (!survey) return Color.neutral

  if (survey.isFinished) return Color.champagne

  if (survey.isScheduled) return Color.grey

  if (survey.isActive) return Color.lime
}

export const getTagLabel = (survey: EnpsForm | Survey | undefined) => {
  if (!survey) return

  if (survey.isFinished)
    return i18n.t('engagement_insights.survey_widget.empty_status.state.inactive')

  if (survey.isScheduled)
    return i18n.t('engagement_insights.survey_widget.empty_status.state.scheduled')

  if (survey.isActive) return i18n.t('engagement_insights.survey_widget.empty_status.state.active')
}
